/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';
import cx from 'clsx';
import {
  trackCreativeClick,
  trackCreativeView,
  trackEvent,
} from '@kcd/event-tracker';

import { getResizeImage } from '~/components/Image';
import { useIntersectionObserver } from '~/hooks/event';

import type { HomeShowcaseListType } from './helper';

type Props = {
  selected: boolean;
  showcase: HomeShowcaseListType[number];
  index: number;
  onClick: () => void;
};

export function HomeShowcaseItem({
  selected,
  showcase,
  index,
  onClick,
}: Props) {
  const viewedCallback = useCallback(() => {
    trackCreativeView({
      adGroupId: showcase.adGroupId,
      creativeId: showcase.creativeId,
      placementName: showcase.placementName || '',
    });
  }, []);

  const onCreativeClicked = useCallback(() => {
    trackCreativeClick({
      adGroupId: showcase.adGroupId,
      creativeId: showcase.creativeId,
      placementName: showcase.placementName || '',
    });
  }, []);

  const ref = useIntersectionObserver(viewedCallback);
  const onClickShowcase = () => {
    onCreativeClicked();

    trackEvent('clicked banner in 마켓/홈_상단', {
      clicked_area: 'side_banner_list',
      index: index + 1,
      ...(showcase.code
        ? { showcase_code: showcase.code }
        : { url: showcase.landingUrl }),
    });

    onClick();
  };

  if (!showcase?.displayRightImageUrl) {
    return null;
  }

  return (
    <div
      ref={ref}
      onClick={onClickShowcase}
      role="presentation"
      style={{
        backgroundImage: `url(${getResizeImage({
          src: showcase.displayRightImageUrl,
          width: 180,
        })})`,
      }}
      className={cx(
        'aspect-square bg-center bg-no-repeat bg-cover relative ml-16 size-[60px] shrink-0 rounded-12 border border-solid border-gray-100',
        selected &&
          'left-0 top-0 border-2 border-primary-regular tooltip after:absolute after:left-[-13px] after:top-20 after:rotate-90 after:border-[#2D91FF_transparent_transparent] after:content-[""]',
      )}
    />
  );
}
